import { render, staticRenderFns } from "./BusinessUnitView.vue?vue&type=template&id=69da4dff&"
import script from "./BusinessUnitView.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports